module.exports = __webpack_public_path__ + "img/spitter-run-2.043749ed.png";